export const FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST = 'FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_RVU_DETAILS_REQUEST';
export const FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_SUCCESS = 'FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_RVU_DETAILS_SUCCESS';
export const FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_FAILURE = 'FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_RVU_DETAILS_FAILURE';

export const FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST = 'FETCH_SITE_HOURLY_VOLUME_SHARE_READ_RVU_DETAILS_REQUEST';
export const FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_SUCCESS = 'FETCH_SITE_HOURLY_VOLUME_SHARE_READ_RVU_DETAILS_SUCCESS';
export const FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_FAILURE = 'FETCH_SITE_HOURLY_VOLUME_SHARE_READ_RVU_DETAILS_FAILURE';

export const EXPORT_SITE_HOURLY_VOLUME_SHARE_REQUEST = 'EXPORT_SITE_HOURLY_VOLUME_SHARE_REQUEST';
export const EXPORT_SITE_HOURLY_VOLUME_SHARE_SUCCESS = 'EXPORT_SITE_HOURLY_VOLUME_SHARE_SUCCESS';
export const EXPORT_SITE_HOURLY_VOLUME_SHARE_FAILURE = 'EXPORT_SITE_HOURLY_VOLUME_SHARE_FAILURE';

export const GET_DROPDOWN_SITE_RAD_REQUEST = 'GET_DROPDOWN_SITE_RAD_REQUEST';
export const GET_DROPDOWN_SITE_RAD_SUCCESS = 'GET_DROPDOWN_SITE_RAD_SUCCESS';
export const GET_DROPDOWN_SITE_RAD_FAILURE = 'GET_DROPDOWN_SITE_RAD_FAILURE';

export const GET_WORKLIST_BY_RPCE_ID_REQUEST = 'GET_WORKLIST_BY_RPCE_ID_REQUEST';
export const GET_WORKLIST_BY_RPCE_ID_SUCCESS = 'GET_WORKLIST_BY_RPCE_ID_SUCCESS';
export const GET_WORKLIST_BY_RPCE_ID_FAILURE = 'GET_WORKLIST_BY_RPCE_ID_FAILURE';

export const GET_PRATICES_BY_WORKLIST_ID_REQUEST = 'GET_PRATICES_BY_WORKLIST_ID_REQUEST';
export const GET_PRATICES_BY_WORKLIST_ID_SUCCESS = 'GET_PRATICES_BY_WORKLIST_ID_SUCCESS';
export const GET_PRATICES_BY_WORKLIST_ID_FAILURE = 'GET_PRATICES_BY_WORKLIST_ID_FAILURE';

export const GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST = 'GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST';
export const GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS = 'GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS';
export const GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE = 'GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE';
